import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, ButtonProps } from "antd"

import { authStore } from "@src/app/authStore"
import { paths } from "@src/app/paths"
import s from "./index.module.css"

export const LogoutButton = observer(
  ({ size = "middle", ...props }: ButtonProps) => {
    const { logout } = authStore
    const navigate = useNavigate()

    return (
      <Button
        {...props}
        className={s.button}
        onClick={() => logout().then(() => navigate(paths.auth))}
        size={size}
      >
        Logout
      </Button>
    )
  },
)
